import dayjs from 'dayjs';

export const daysOptions = [
  {
    label: 'September 5, 2018',
    value: dayjs('September 5, 2018').valueOf(),
  },
  {
    label: 'September 6, 2018',
    value: dayjs('September 6, 2018').valueOf(),
  },
  {
    label: 'September 7, 2018',
    value: dayjs('September 7, 2018').valueOf(),
  },
  {
    label: 'September 10, 2018',
    value: dayjs('September 10, 2018').valueOf(),
  },
  {
    label: 'September 11, 2018',
    value: dayjs('September 11, 2018').valueOf(),
  },
  {
    label: 'September 12, 2018',
    value: dayjs('September 12, 2018').valueOf(),
  },
  {
    label: 'September 13, 2018',
    value: dayjs('September 13, 2018').valueOf(),
  },
  {
    label: 'September 14, 2018',
    value: dayjs('September 14, 2018').valueOf(),
  },
  {
    label: 'September 17, 2018',
    value: dayjs('September 17, 2018').valueOf(),
  },
  {
    label: 'September 18, 2018',
    value: dayjs('September 18, 2018').valueOf(),
  },
  {
    label: 'September 19, 2018',
    value: dayjs('September 19, 2018').valueOf(),
  },
  {
    label: 'September 20, 2018',
    value: dayjs('September 20, 2018').valueOf(),
  },
  {
    label: 'September 21, 2018',
    value: dayjs('September 21, 2018').valueOf(),
  },
  {
    label: 'September 24, 2018',
    value: dayjs('September 24, 2018').valueOf(),
  },
  {
    label: 'September 25, 2018',
    value: dayjs('September 25, 2018').valueOf(),
  },
  {
    label: 'September 26, 2018',
    value: dayjs('September 26, 2018').valueOf(),
  },
  {
    label: 'September 27, 2018',
    value: dayjs('September 27, 2018').valueOf(),
  },
  {
    label: 'September 28, 2018',
    value: dayjs('September 28, 2018').valueOf(),
  },
  {
    label: 'October 3, 2018',
    value: dayjs('October 3, 2018').valueOf(),
  },
  {
    label: 'October 4, 2018',
    value: dayjs('October 4, 2018').valueOf(),
  },
  {
    label: 'October 8, 2018',
    value: dayjs('October 8, 2018').valueOf(),
  },
  {
    label: 'October 9, 2018',
    value: dayjs('October 9, 2018').valueOf(),
  },
  {
    label: 'October 11, 2018',
    value: dayjs('October 11, 2018').valueOf(),
  },
  {
    label: 'October 12, 2018',
    value: dayjs('October 12, 2018').valueOf(),
  },
  {
    label: 'October 15, 2018',
    value: dayjs('October 15, 2018').valueOf(),
  },
  {
    label: 'October 16, 2018',
    value: dayjs('October 16, 2018').valueOf(),
  },
  {
    label: 'October 17, 2018',
    value: dayjs('October 17, 2018').valueOf(),
  },
  {
    label: 'October 19, 2018',
    value: dayjs('October 19, 2018').valueOf(),
  },
  {
    label: 'October 22, 2018',
    value: dayjs('October 22, 2018').valueOf(),
  },
  {
    label: 'October 23, 2018',
    value: dayjs('October 23, 2018').valueOf(),
  },
  {
    label: 'October 24, 2018',
    value: dayjs('October 24, 2018').valueOf(),
  },
  {
    label: 'October 25, 2018',
    value: dayjs('October 25, 2018').valueOf(),
  },
  {
    label: 'October 26, 2018',
    value: dayjs('October 26, 2018').valueOf(),
  },
];

export const cityOptions = [
  {
    label: 'Atlanta',
    value: 'Atlanta',
  },
  {
    label: 'Boston',
    value: 'Boston',
  },
  {
    label: 'Charlotte',
    value: 'Charlotte',
  },
  {
    label: 'Chicago',
    value: 'Chicago',
  },
  {
    label: 'Cincinnati',
    value: 'Cincinnati',
  },
  {
    label: 'Dallas',
    value: 'Dallas',
  },
  {
    label: 'Denver',
    value: 'Denver',
  },
  {
    label: 'Harrisburg',
    value: 'Harrisburg',
  },
  {
    label: 'Houston',
    value: 'Houston',
  },
  {
    label: 'Kansas City',
    value: 'Kansas City',
  },
  {
    label: 'Los Angeles',
    value: 'Los Angeles',
  },
  {
    label: 'Millville',
    value: 'Millville',
  },
  {
    label: 'Minneapolis',
    value: 'Minneapolis',
  },
  {
    label: 'Newark',
    value: 'Newark',
  },
  {
    label: 'Orlando',
    value: 'Orlando',
  },
  {
    label: 'Philadelphia',
    value: 'Philadelphia',
  },
  {
    label: 'Phoenix',
    value: 'Phoenix',
  },
  {
    label: 'Pittsburgh',
    value: 'Pittsburgh',
  },
  {
    label: 'Portland',
    value: 'Portland',
  },
  {
    label: 'Richmond',
    value: 'Richmond',
  },
  {
    label: 'Sacramento',
    value: 'Sacramento',
  },
  {
    label: 'Salt Lake City',
    value: 'Salt Lake City',
  },
  {
    label: 'San Diego',
    value: 'San Diego',
  },
  {
    label: 'San Francisco',
    value: 'San Francisco',
  },
  {
    label: 'Seattle',
    value: 'Seattle',
  },
  {
    label: 'Syracuse',
    value: 'Syracuse',
  },
  {
    label: 'Toledo',
    value: 'Toledo',
  },
  {
    label: 'Tulsa',
    value: 'Tulsa',
  },
  {
    label: 'Washington, D.C.',
    value: 'Washington, D.C.',
  },
];

export const groupOptions = [
  {
    label: 'AM1 - Green Lanyard',
    value: 'AM1 - Green Lanyard',
  },
  {
    label: 'AM2 - Orange Lanyard',
    value: 'AM2 - Orange Lanyard',
  },
  {
    label: 'AM3 - Blue Lanyard',
    value: 'AM3 - Blue Lanyard',
  },
  {
    label: 'AM4 - Gray Lanyard',
    value: 'AM4 - Gray Lanyard',
  },
  {
    label: 'PM1 - Green Lanyard',
    value: 'PM1 - Green Lanyard',
  },
  {
    label: 'PM2 - Orange Lanyard',
    value: 'PM2 - Orange Lanyard',
  },
  {
    label: 'PM3 - Blue Lanyard',
    value: 'PM3 - Blue Lanyard',
  },
  {
    label: 'PM4 - Gray Lanyard',
    value: 'PM4 - Gray Lanyard',
  },
];



// WEBPACK FOOTER //
// ./src/data/index.js